<template>     
    <!-- Inizio repeater repeater repeater -->
    <tr>
    <td class="TORCod">
        <span>Codice ricambio</span>{{this.ricambio.CodiceArticolo}}
    </td>
    <td class="TORRic">
        <span>Descrizione ricambio</span>{{this.ricambio.DescrizioneArticolo}}
    </td>
    <td class="TORUni"><span>Unità mis.</span>{{this.ricambio.UnitaMisura}}</td>
    <td class="TORQtp"><span>Q.tà prevista</span>{{this.ricambio.QtaPrevista}}</td>
    <td class="TORQty"><span>Q.tà effettiva</span>{{this.ricambio.QtaEffettiva}}</td>
    <td class="TORChe">
        <span>Incluso</span>
        <i class="CheckIcon"><img src="/App_Skins/Sito/images/CheckIcon.png" srcset="/App_Skins/Sito/images/CheckIconRetina.png 2x" alt="" v-show="this.ricambio.Incluso"/></i>
    </td>
    <td class="TORQty"><span>Magazzino</span>{{this.ricambio.DescrizioneMagazzino}}</td>
    </tr>
    <!-- Fine repeater repeater repeater -->    
</template>

<script>
export default {
    name: "RicambioRiga",
    props:{
        ricambio: Object
    }
}
</script>
